import TicketsDataActions from "../../../../redux/feature/TicketPortal/actions/TicketsData";
import createTicketActions from "../../../../redux/feature/TicketPortal/actions/CreateTicket";
export default () => {
    return {
        ticketData: {
            getTicketsData: new TicketsDataActions(),
            createTicketData: new createTicketActions(),
        },
    };
};
